import React from 'react'
import moment from 'moment'
import classnames from 'classnames'
import { startCase } from 'lodash'
import { selectedUrl } from '../../../../../../utils'

export default function AgendaItem(props) {
  const { title, description, due_date, status, url, kind, starts_at, ends_at, starts_at_time, ends_at_time, all_day, anchorDate } = props
  return (
    <a href={url}
      target="_blank"
      className="border-rounded pt-2 pb-2 pl-3 pr-3 border d-block clickable hoverable mb-1 cursor-pointer bg-white"
      style={{ textDecoration: 'none', color: 'black' }}>
      <div className="d-flex justify-content-between align-items-start">
        <small className="font-weight-bold text-secondary text-uppercase">{kind}</small>
      </div>
      <b className="d-block">{title || 'No Title'}</b>
      <p className="mb-0"><i>{description || (props.kind === 'Drug Test Request' ? 'No Title' : 'No Description')}</i></p>
      <small className="text-secondary text-uppercase" style={{ fontWeight: '600' }}>
        {
          due_date ?
            <span>due by {moment(due_date).format("LL")}</span>
            : all_day ?
              <span>{moment(starts_at).format('LL')} - {moment(ends_at).format('LL')}</span>
              :
              <span>{(starts_at_time || moment(starts_at).format('h:mm a'))} - {(ends_at_time || moment(ends_at).format('h:mm a'))}</span>
        }

      </small>
      <div className="mt-1 mb-1"><Status status={status} anchorDate={anchorDate} /></div>
    </a>
  )
}

function Status(props) {
  const { anchorDate } = props

  function getStatus() {
    switch (props.status) {
      case "no_checkin":
      case "current":
        if (moment(anchorDate).isBefore(moment().startOf("days"))) {
          return props.status == "no_checkin" ? "missed" : 'overdue'
        } else {
          if (moment(anchorDate).startOf("days").isSame(moment().startOf("days"))) {
            return 'pending'
          } else {
            return 'upcoming'
          }
        }
      case "pending_completing":
        return 'pending'
      default:
        return props.status
    }
  }

  const status = getStatus()

  /*
    1. categorize as completed or pending
    2. categorize as upcoming or due

  */

  return (
    <div className={classnames("badge", {
      "badge-success": (status == 'completed' || status == 'checked_in' || status == 'completed'),
      "badge-warning": (status == 'current' || status == 'no_checkin' || status == 'pending'),
      "badge-secondary": status == 'upcoming' || status == 'Scheduled',
      "badge-danger": status == 'completed_late' || status == 'overdue' || status == 'missed' || status == 'Skipped',
    })}>
      {startCase(getStatus())}
    </div>
  )
}

export function ResourceComponent(props) {
  switch (props.resource_type) {
    case "Event":
    case "Checkin":
      return <AgendaItem
        kind={"Event"}
        title={props.title}
        anchorDate={props.anchor_date}
        description={props.description}
        starts_at={props.starts_at}
        starts_at_time={props.starts_at_time}
        ends_at={props.ends_at}
        ends_at_time={props.ends_at_time}
        status={props.status}
        url={`/organizations/${props.organization.name}/events/${props.id}${props.status == 'pending_completing' ? '/review' : ''}?starts_at=${props.starts_at}&ends_at=${props.ends_at}`}
      />
    case "Goal":
      return <AgendaItem
        kind={props.resource_type}
        title={props.title}
        anchorDate={props.anchor_date}
        description={props.description}
        due_date={props.due}
        status={props.status}
        url={`/organizations/${props.organization.name}/goals/${props.id}${props.status == 'pending_completing' ? '/review' : ''}`}
      />
    case "FormRequest":
      return <AgendaItem
        kind="Form Request"
        title={props.form.title}
        anchorDate={props.anchor_date}
        description={props.notes}
        due_date={props.due_date}
        status={props.status}
        url={`/organizations/${props.organization.name}/form_requests/${props.id}${props.status == 'pending_completing' ? '/review' : ''}`}
      />
    case "SurveyRequest":
      return <AgendaItem
        kind="Survey Request"
        title={props.resident_survey.name}
        anchorDate={props.anchor_date}
        description={props.notes}
        due_date={props.due_date}
        status={props.status}
        url={`/organizations/${props.organization.name}/survey_requests/${props.id}${props.status == 'pending_completing' ? '/review' : ''}`}
      />
    case "DrugTestRequest":
      return <AgendaItem
        kind="Drug Test Request"
        title={props.kind}
        anchorDate={props.anchor_date}
        description={props.name}
        due_date={props.due_date}
        status={props.status}
        url={selectedUrl(props)}
      />
    default:
      return <div className="p-3 border mb-3 w-100">{JSON.stringify(props)}</div>
  }
}
